/**
 * Plugin ID for app-standard-insights
 */
export const APP_SEC_INSIGHTS_PLUGIN_ID = 'app-standard-insights';

/**
 * API endpoints
 */
export const APP_SEC_INSIGHTS_API_ENDPOINTS = {
  DATA: '/data',
} as const;
